import React, { PureComponent } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import ClampLines from 'react-clamp-lines';
import appConstant from '../../../../constants/app';
import {PageView, Event} from '../../../components/baseComponents/Tracking';

class LinksResult extends PureComponent {
  static propTypes = {
    links: PropTypes.array.isRequired,
  };
  
  static defaultProps = {
    links: [],
  };

  componentDidMount() {
    PageView();
  }

  onPressAction = (id, label, hidden, action) => {
    this.props.showModalHandle(id, label, hidden, action);
  }

  onClickTrendingLink = (e, linkId, linkLabel) => {
    Event("Links", "Click", linkLabel)

    axios({
      method: 'post',
      url: `${appConstant.API_URL}/link/click`, 
      data: {
        id: linkId,
      },
    })
    .then(res => {
    }).catch(err => {
      console.log(err);
    });
  }

  render () {
    const {
      links,
    } = this.props;

    let httpUrl;

    return (
      links.map((link, index) => {
        httpUrl = (link.url.includes('http')) ? link.url : `http://${link.url}`;

        return (
          <a
            target="_blank"
            href={httpUrl}
            title={link.label}
            style={{position: 'relative',}}
            className="link-item-a"
            rel="noopener noreferrer"
            onClick={(e) => {
              this.onClickTrendingLink(e, link.id, link.label)
            }}
          >
          <div className="link-item" key={`link-${index}-item`}>
            <div>
              <img src={link.icon && link.icon.icon_path} alt="" style={{width: '24px', height: '24px',}} />
            </div>
            <div style={{ width: '100%' }}>
              <h3>
                <div className="link-result-label-a">
                  {link.label}
                </div>
              </h3>
              <p title={link.description}>
                <ClampLines
                  buttons={false}
                  lines="2"
                  text={link.description}
                />
              </p>
            </div>
          </div>
          </a>
        );
      })
    );
  }
}

export default LinksResult;



// WEBPACK FOOTER //
// ./src/app/screens/landing/links/linksResult.js